import React from 'react';

// Import all service images
import massageImg from './massage.png';
import reflectionImg from './reflection.png';
import cuppingImg from './cupping.png';
import faceImg from './face.png';
import kretekImg from './kretek.png';
import stoneImg from './stone.png';
import scrappingImg from './scrapping.png';
import scrubImg from './scrub.png';
import kidsMassageImg from './kidsmassage.png';

interface ServiceImageProps {
  className?: string;
  size?: number;
  alt?: string;
}

// Service Image Components
export const MassageServiceImage: React.FC<ServiceImageProps> = ({ 
  className = '', 
  size = 64, 
  alt = 'Full Body Massage' 
}) => (
  <img 
    src={massageImg} 
    alt={alt}
    className={className}
    style={{ width: size, height: size }}
  />
);

export const ReflectionServiceImage: React.FC<ServiceImageProps> = ({ 
  className = '', 
  size = 64, 
  alt = 'Reflection Massage' 
}) => (
  <img 
    src={reflectionImg} 
    alt={alt}
    className={className}
    style={{ width: size, height: size }}
  />
);

export const CuppingServiceImage: React.FC<ServiceImageProps> = ({ 
  className = '', 
  size = 64, 
  alt = 'Cupping Massage' 
}) => (
  <img 
    src={cuppingImg} 
    alt={alt}
    className={className}
    style={{ width: size, height: size }}
  />
);

export const FaceServiceImage: React.FC<ServiceImageProps> = ({ 
  className = '', 
  size = 64, 
  alt = 'Face Massage' 
}) => (
  <img 
    src={faceImg} 
    alt={alt}
    className={className}
    style={{ width: size, height: size }}
  />
);

export const KretekServiceImage: React.FC<ServiceImageProps> = ({ 
  className = '', 
  size = 64, 
  alt = 'Injury Massage (Kretek)' 
}) => (
  <img 
    src={kretekImg} 
    alt={alt}
    className={className}
    style={{ width: size, height: size }}
  />
);

export const StoneServiceImage: React.FC<ServiceImageProps> = ({ 
  className = '', 
  size = 64, 
  alt = 'Hot Stone Massage' 
}) => (
  <img 
    src={stoneImg} 
    alt={alt}
    className={className}
    style={{ width: size, height: size }}
  />
);

export const ScrappingServiceImage: React.FC<ServiceImageProps> = ({ 
  className = '', 
  size = 64, 
  alt = 'Scrapping (Kerok)' 
}) => (
  <img 
    src={scrappingImg} 
    alt={alt}
    className={className}
    style={{ width: size, height: size }}
  />
);

export const ScrubServiceImage: React.FC<ServiceImageProps> = ({ 
  className = '', 
  size = 64, 
  alt = 'Body Scrub' 
}) => (
  <img 
    src={scrubImg} 
    alt={alt}
    className={className}
    style={{ width: size, height: size }}
  />
);

export const KidsMassageServiceImage: React.FC<ServiceImageProps> = ({ 
  className = '', 
  size = 64, 
  alt = 'Kids Massage' 
}) => (
  <img 
    src={kidsMassageImg} 
    alt={alt}
    className={className}
    style={{ width: size, height: size }}
  />
);
